"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.AccessoryAssetBuilder = exports.AccessoryAsset = void 0;
var core_common_logic_1 = require("@jewelutions/core-common-logic");
var AccessoryAsset = /** @class */ (function () {
    function AccessoryAsset() {
    }
    AccessoryAsset.getAccessories = function (accessoryAssets) {
        return accessoryAssets.map(function (asset) { return asset.accessory; });
    };
    return AccessoryAsset;
}());
exports.AccessoryAsset = AccessoryAsset;
var AccessoryAssetBuilder = /** @class */ (function () {
    function AccessoryAssetBuilder(accessoryAsset) {
        this.accessoryAsset = accessoryAsset;
    }
    AccessoryAssetBuilder.initialiseWithAccessoryAsset = function (accessoryAsset) {
        return new AccessoryAssetBuilder(accessoryAsset);
    };
    AccessoryAssetBuilder.initialise = function (ownerPartyId, sharedWithEveryone, accessory) {
        return AccessoryAssetBuilder.initialiseWithAccessoryAsset({
            id: accessory.id,
            ownerPartyId: ownerPartyId,
            public: sharedWithEveryone,
            accessory: accessory,
            createdAt: core_common_logic_1.CommonLogic.nowToDateTime(),
            updatedAt: core_common_logic_1.CommonLogic.nowToDateTime()
        });
    };
    AccessoryAssetBuilder.prototype.build = function () {
        return this.accessoryAsset;
    };
    AccessoryAssetBuilder.prototype.buildUpdate = function () {
        return {
            ownerPartyId: this.accessoryAsset.ownerPartyId,
            public: this.accessoryAsset.public,
            accessory: this.accessoryAsset.accessory
        };
    };
    AccessoryAssetBuilder.prototype.getId = function () {
        return this.accessoryAsset.id;
    };
    AccessoryAssetBuilder.prototype.withId = function (id) {
        this.accessoryAsset.id = id;
        this.accessoryAsset.accessory.id = id;
        return this;
    };
    AccessoryAssetBuilder.prototype.withAccessoryUpdate = function (accessoryUpdate) {
        this.accessoryAsset = {
            id: this.accessoryAsset.id,
            ownerPartyId: this.accessoryAsset.ownerPartyId,
            public: this.accessoryAsset.public,
            accessory: __assign(__assign({}, this.accessoryAsset.accessory), accessoryUpdate),
            createdAt: this.accessoryAsset.createdAt,
            updatedAt: core_common_logic_1.CommonLogic.nowToDateTime()
        };
        return this;
    };
    return AccessoryAssetBuilder;
}());
exports.AccessoryAssetBuilder = AccessoryAssetBuilder;
